module.exports = __webpack_public_path__ + "img/home_with_garden_and_fertilizer_3.e258d93a.png";